<template>
	<div class="beijing">
		<div class="shop">
			<!-- 顶部导航 -->
			<div class="nav">
				<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
				<span>预约上门</span>
				<span></span>
			</div>

			<div class="container">
				<div class="yuyueshijian">
					<van-field v-model="type">

						<div slot="label">预约日期</div>
						<van-cell slot="input" class="address" :title="type" is-link :value-class="className" :value="timeValue" @click="showPopup" />

						<div>sdsd</div>
					</van-field>

					<van-radio-group v-model="radio" class="radioo">
						<van-radio name="上午">上午</van-radio>
						<van-radio name="下午">下午</van-radio>
					</van-radio-group>


				</div>




				<!-- <van-field v-model="make_address" label="预约地址:" placeholder="请输入预约地址" /> -->
				<div class="shenshi">

					<van-field class="ads" v-model="addressde" name="province">
						<div slot="label">预约地区</div>
						<van-cell class="address" slot="input" :title="addressde" is-link @click="select=true" />
					</van-field>
				</div>

				<van-field v-model="make_address" label="详细地址" placeholder="请输入详细预约地址" />
				<van-field v-model="tel" label="手机号" clearable placeholder="请输入手机号" />
				<van-field v-model="addressMsg" label="验证码" placeholder="验证码">
					<van-button slot="button" size="small" type="primary" @click="getcode">{{buttonMsg}}

					</van-button>
				</van-field>

				<van-field v-model="lxr" label="联系人" placeholder="请输入联系人姓名" />
				<div class="gongcheng">
					<van-field name="面积" v-model="size" type="number" label="工程面积" placeholder="请输入工程面积">
						<div slot="right-icon" style="color:#000">m²</div>
					</van-field>
				</div>

				<!-- <van-field v-model="size" type="number" label="工程面积:" placeholder="请输入工程面积"/>
            <div slot="right-icon" style="color:#000">m²</div>
        </van-field> -->
				<van-field v-model="make_brand" label="意向品牌" placeholder="请输入意向品牌" />



				<div class="submit">
					<van-button round color="#F1452F" size="small" @click="submit">提交预约</van-button>
				</div>

				<div class="keyixuan"> <span>你可以选择以下方式预约</span></div>
				<div class="xuanzeyuyue">
					<div class="bodahezi">
						<div class="bodarre">
							<span><img src="../../assets/tupian/座机.png" alt=""></span>
							<span class="bodarenxian"><a :href="'tel:' + 4008722000">拨打热线</a></span>

						</div>
						<div class="bodarresai">
							<span><img src="../../assets/tupian/在线客服.png" alt=""></span>
							<span @click="open53">在线客服</span>

						</div>


					</div>

				</div>
				<!-- 详细地址 -->
				<!-- <van-popup v-model="showAds" position="bottom" :style="{ 'height': '95%' }">
                    <Map @close="close" @sites="sites"></Map>
                </van-popup> -->
				<van-popup v-model="show" position="bottom">
					<van-datetime-picker v-model="make_time" type="date" title="选择时间" :loading="isLoadingShow" :min-date="minDate"
					 :max-date="maxDate" :formatter="formatter" @cancel="show = false" @confirm="confirmPicker" />
				</van-popup>
				<!-- 城市选择 -->
				<van-popup v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
					<van-area :area-list="areaList" @confirm="areaOk" @cancel="select=false" />
				</van-popup>
				<!-- <van-popup v-model="server" position="bottom" :style="{ 'max-height': '80%' }">
                <van-datetime-picker 
                v-model="make_time" 
                @cancel="server=false" 
                @confirm="onConfirm" 
                type="date"
                :formatter="formatter"
                    title="选择年月日" />
                <van-picker :columns="columns" show-toolbar @cancel="server=false" @confirm="onConfirm" /> 
            </van-popup> -->
			</div>
		</div>
	</div>
</template>

<script>
	let moment = require("moment");
	import areaList from "@/assets/js/area.js"
	import {
		publicMethod
	} from "../../assets/js/publicMethod";
	import Map from '@/components/map';
	import {
		ImagePreview
	} from 'vant';
	import {
		compressImage
	} from '../../assets//js/compressImage';
	const myImage = new Image();
	var formData = new FormData();
	export default {
		data() {
			return {

				areaList,
				radio: '上午',
				sedeka: '',
				select: false,
				addressde: '请选择城市',
				addressde: '请选择城市',
				msg: '商家页面',
				timeValue: '请选择日期',
				show: false,
				isLoadingShow: true,
				minDate: new Date(),
				maxDate: new Date(),
				className: '',
				adeimg: '',
				fileIds: [],
				fileListA: [],
				fileListB: [],
				formArrayA: [],
				formArrayB: [],
				shop: '',
				code: '',

				make_address: '', //预约地址
				make_time: '', //时间戳
				size: '', //请输入工程面积
				tel: '', //请输入手机号码
				lxr: '', //请输入联系人姓名
				buttonMsg: '获取验证码',
				make_brand: '',
				address: '',
				work: '',

				addressMsg: '',

				iphon: '',
				codes: '',
				tel: '',
				message: '',
				server: false,
				columns: [],
				province: '',
				city: '',
				area: '',
				category_id: '',
				error_msg: '10',
				error: true,
				showWordLimit: false,
				showAds: false,
				lat: '',
				lng: ''
			}
		},
		components: {
			Map
		},
		created() {

			let nowDate = new Date()
			var year = nowDate.getFullYear()
			var month = nowDate.getMonth()
			var day = nowDate.getDate()
			// var h = nowDate.getHours()
			// var m = nowDate.getMinutes()
			this.minDate = new Date(year, month, day + 1)
			this.maxDate = new Date(year, month + 2, day + 1)
			//  this.getTime();
			// 服务分类
		},
		watch: {
			'message': function(value) {
				if (value.length > 10) {
					this.error = false;
					this.showWordLimit = true;
				} else {
					this.error = true;
					this.showWordLimit = false;
					this.error_msg = 10 - parseInt(value.length);
				}
			}
		},
		methods: {
			// 显示弹窗
			showPopup() {
				this.show = true
				this.isLoadingShow = true
				setTimeout(() => {
					this.isLoadingShow = false
				}, 500)
			},
			// 确认选择的时间
			confirmPicker(val) {
				let year = val.getFullYear()
				let month = val.getMonth() + 1
				let day = val.getDate()
				//     let hour = val.getHours()
				//  let minute = val.getMinutes()
				//:${minute}
				this.className = 'timeClass'
				this.timeValue = `${year}-${month}-${day}`
				this.show = false
			},
			// 选项格式化函数
			formatter(type, value) {
				if (type === 'year') {
					return `${value}年`
				} else if (type === 'month') {
					return `${value}月`
				} else if (type === 'day') {
					return `${value}日`
				}
				return value
			},

			//立即入驻
			submit() {
				if (this.make_time == '') {
					this.$toast('请选择预约时间');
					return false;
				};
				if (this.make_address == '') {
					this.$toast('预约地址');
					return false;
				};
				if (this.size == '') {
					this.$toast('请输入工程面积');
					return false;
				};
				if (this.tel == '') {
					this.$toast('请输入手机号');
					return false;
				};
				if (this.tel == '') {
					this.$toast('手机号不能为空！');
					return false;
				};
				if (this.tel && (!(/^[1][345789]\d{9}$/).test(this.tel) || !(/^[1-9]\d*$/).test(this.tel) ||
						this.tel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				};
				if (this.addressMsg == '') {
					this.$toast('验证码!');
					return false;
				};
				if (this.tel != this.iphon || this.addressMsg != this.codes) {
					this.$toast('验证码错误');
					return false;
				}

				if (this.lxr == '') {
					this.$toast('请输入联系人姓名!');
					return false;
				};
				var d = this.make_time
				var datetime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
				this.$axios.post(baseUrl + '/mobile/Base/make', {
					make_time: datetime,
					make_address: this.make_address,
					size: this.size,
					tel: this.tel,
					lxr: this.lxr,
					time_section: this.radio,
					make_brand: this.make_brand,
					province: this.province,
					city: this.city,
					area: this.area
				}).then((res) => {
					if (res.data.code === 19) {
						const toast = this.$toast.loading({
							message: res.data.msg,
							icon: 'http://image.jbj-china.com.cn/img/yuyue.png',
							duration: 2000,
						});
						//清除延迟执行 
						clearTimeout(this.timer);
						this.timer = setTimeout(() => { //设置延迟执行
							this.back();
						}, 100);

					}
				}).catch(() => {
					console.log(err);
				})

			},
			//获取验证码
			getcode() {

				if (this.tel === '') {
					this.$toast('请填写手机号');
					return false;
				} else if (this.tel && (!(/^[1][345789]\d{9}$/).test(this.tel) || !(/^[1-9]\d*$/).test(this.tel) ||
						this.tel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				} else {
					this.code = false
				}
				this.$axios.post(baseUrl + '/mobile/Base/get_code', {
					tel: this.tel
				}).then((res) => {
					console.log(res)

					if (res.data.code == 2001) {
						this.$toast(res.data.msg);
						this.iphon = res.data.data.tel;
						this.codes = res.data.data.code;

						this.buttonMsg = 60;
						this.code = true
						var auth_timer = setInterval(() => {
							this.buttonMsg--;
							if (this.buttonMsg <= 0) {
								this.buttonMsg = '获取验证码'
								this.code = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			},

			getImg(formArrayB, index) {
				ImagePreview({
					formArrayB: this.formArrayB,
					showIndex: true,
					loop: true,
					startPosition: index,
					closeOnPopstate: true
				})
				console.log(index);
				console.log(formArrayB);
			},


			//   //获取图片路径
			getFileList(ary, fmData) {
				fmData.push({
					url: 'http://backstage.jbj-china.com.cn/uploads' + ary,
					isImage: false
				})
			},
			//关闭选择地址
			close(res) {
				this.showAds = res;
			},
			//分类确认选择
			onConfirm(value, index) {
				this.server = false;
				this.type = value.toString();
				this.category_id = this.columns[index[0]].children[index[1]].id;
			},
			//显示地址选择框
			onAddrConfirm(value, index) {
				this.server = false
				this.typee = value.toString();

			},
			//显示地址取消
			onAddrcancel() {
				this.server = false
			},
			//选中地址
			areaOk(event) {
				this.addressde = '';
				for (var item in event) {
					this.addressde += event[item].name;
				}
				this.province = event[0].name;
				this.city = event[1].name;
				this.area = event[2].name;
				this.select = false;
			},

		}
	}
</script>

<style scoped>
	.gongcheng>>>.van-field__control {
		width: 40%;
	}

	.gongcheng {
		border-bottom: 1px solid #ebedf0;
	}


	.shenshi>>>.van-cell__title span {
		position: relative;
		top: -0.6rem;
		left: -1rem;

	}

	.yuyueshijian>>>.van-cell .van-field {
		border-bottom: 0px solid #ebedf0;
	}

	.yuyueshijian>>>.van-cell {
		border: 0px solid red;
	}

	.yuyueshijian {
		border-bottom: 1px solid #ebedf0;
		display: flex;
	}

	.yuyueshijian>>>.van-field__body .van-cell__right-icon {
		margin-left: 0.3rem !important;
		right: 1.5rem;
	}

	.radioo {
		top: 0.1rem;
		position: relative;
		left: -2rem;
		/* top: -2rem;
    left: 11rem;
    position: relative; */
		display: -webkit-box !important;
	}

	.radioo>>>.van-radio__icon .van-icon {
		width: 0.9em;
		height: 0.9em;
		position: relative;
		top: 0.2rem;
	}

	.yuyueshijian>>>.van-radio__icon {
		line-height: 0.5em;
	}

	.radioo>>>.van-radio__label {
		color: #323233;
		font-size: 0.75rem;
		margin-left: 0.3rem;
	}

	.radioo>>>.van-radio:nth-child(2) {
		margin-right: 0.6rem;
		margin-left: 1rem;

	}

	.yanse {
		width: 2rem;
		background: red;
	}

	.beijing {
		background: #ffffff;
	}

	.shop>>>.van-toast {
		width: 60%;
		max-width: 70%;
	}

	.bodarre span:nth-child(2) {
		position: relative;
		top: 0.2rem;
	}

	.bodarresai span:nth-child(2) {
		color: rgba(40, 51, 75, .7);
		position: relative;
		top: .28rem;
		font-size: .8rem;
		left: .2rem;
	}

	.bodarresai {
		border: 1px solid red;
		height: 1.8rem;
		width: 30%;
		border-radius: 1rem;
		line-height: 1.2rem;
	}

	.bodarresai img {
		height: 15px;
		width: 15px;
		position: relative;
		top: .4rem;
	}

	.keyixuan {
		position: relative;
		top: 2.4rem;
	}

	.keyixuan span {
		text-align: left;
		margin-left: 1rem;
		color: #646566;
		font-size: 0.9rem;

	}

	.container>>>.van-cell {
		height: 3.5rem;

	}

	/* .labell{
       overflow: hidden;
    } */

	.shop {
		padding-top: 2rem;
		height: 100vh;
		background: #ffffff;
	}

	.shop>>>.van-cell__right-icon {
		margin-top: -0.2rem;
		/* margin-top: 0.4rem; */
	}

	.bodahezi {
		display: flex;
		justify-content: space-evenly;
	}

	.default .delte {

		position: relative;
		top: -41px;
		left: 1.1rem;
		color: #969799;
		z-index: 88;
		font-size: 18px;
		background-color: #fff;
		border-radius: 100%;

	}

	.default>span {
		width: 50px;
		color: #969799;
		font-size: 18px;
		z-index: 999;
		background-color: #fff;
		border-radius: 100%;

	}

	.bodarenxian a {
		position: relative;
		left: .2rem;
		font-size: .8rem;
		top: .1rem;
		color: rgba(40, 51, 75, .7);
	}

	.container>>>.van-button--primary {
		border-radius: 1rem;
		color: #fff;
		background-color: #07c160;
		/* border: 1px solid #c8c9cc; */
	}

	.container>>>.van-field__control {}

	.container>>>.van-cell__value--alone {
		position: relative;
		top: -0.6rem;
		left: -0.9rem;

	}

	.default span>img {
		position: relative;
		top: 1.7rem;
		left: 2rem;
		object-fit: cover;
		width: 80px;
		height: 80px;
		overflow: hidden;
		border-radius: 8px;
	}

	.shop .container .van-cell:nth-child(1).van-field__value:nth-child(1) {
		position: relative;
		top: 0.2rem;
	}

	.xuanzeyuyue {
		text-align: center;
		height: 6rem;
	}


	.default>>>.van-uploader__upload {
		margin: 23px 8px 8px 2px !important;
	}

	.shop .container .van-cell:nth-child(1) {
		border: 0px solid;
	}

	.shop .container .van-cell {
		font-size: 0.8rem;
		line-height: 2.5rem;
		border-bottom: 1px solid #ebedf0;
	}

	.shop .van-field__label span {
		width: 100%;
	}

	.shenshi .van-cell:nth-child(1) {
		border-bottom: 1px solid #ebedf0 !important;
	}


	.shop .container,
	.shop .article,
	.shop .footer {

		border-radius: 0.3rem;
		overflow: hidden;
		text-align: left;
	}

	.shop .article .van-panel__header,
	.shop .footer .van-panel__header {
		border-bottom: 1px solid #ebedf0;
	}

	.shop .van-cell:not(:last-child)::after {
		border: 0;
	}

	.shop .article .van-field__word-limit {
		padding: 0 1rem 1rem 0;
		box-sizing: border-box;
	}

	.shop .article .van-field__word-limit span {
		color: #F1452F;
		font-weight: bold;
	}

	.shop .van-uploader {
		margin: 0.7rem 0 0 1.9rem;
	}

	.shop .tips {
		font-size: 0.75rem;
		color: #c4c4c4;
	}

	.shop .footer .tips {
		padding: 0 0.7rem 0.5rem 0;
		text-align: right;
	}


	.shop .submit {
		text-align: center;
		height: 2rem;
		width: 100%;
		top: 1.2rem;
		position: relative;
		z-index: 999;
	}

	.shop .submit .van-button {
		font-size: 16px;
		width: 80%;
	}

	.bodarresai {
		position: relative;
		top: 3.9rem;
	}

	.submit .shop .address {
		padding: 0;
		border-top: 0 !important;
	}

	.shop .van-radios {
		font-size: 0.75rem;
		width: 65%;
		justify-content: space-between;
		display: flex;
	}

	.defaka {
		position: relative;
		top: -1rem;
	}

	.bodarre {
		position: relative;
		top: 3.9rem;
		border: 1px solid red;
		height: 1.8rem;
		width: 30%;
		border-radius: 1rem;
		line-height: 1.2rem;

	}

	.bodarre img {
		height: 15px;
		width: 15px;
		position: relative;
		top: .4rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/yuyueshangmen/yuyueshangmen.vue